import React, { useState } from "react";
import axios from "axios";
import "./Chatbot.css";
import chatbotIcon from "../assets/chatbot-icon.png"; // Ensure this image exists

const Chatbot = () => {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [isOpen, setIsOpen] = useState(false); // Initially closed

    const sendMessage = async () => {
        if (!input.trim()) return;

        const newMessages = [...messages, { sender: "user", text: input }];
        setMessages(newMessages); // Update state with user message

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/chat`, { message: input });
            console.log("Chatbot response:", response.data); // Debugging

            // Correct key (`response.data.response` instead of `response.data.reply`)
            setMessages([...newMessages, { sender: "bot", text: response.data.response }]);
        } catch (error) {
            console.error("Chatbot error:", error);
            setMessages([...newMessages, { sender: "bot", text: "Sorry, there was an error." }]);
        }

        setInput(""); // Clear input field
    };

    return (
        <>
            {/* Chat Toggle Button */}
            {!isOpen && (
                <button className="chat-toggle-btn" onClick={() => setIsOpen(true)}>💬</button>
            )}

            {/* Chat Container */}
            {isOpen && (
                <div className="chat-container">
                    {/* Chatbot Header */}
                    <div className="chat-header">
                        <img src={chatbotIcon} alt="Chatbot" className="chatbot-icon" />
                        <span>Chat with us</span>
                        <button className="close-btn" onClick={() => setIsOpen(false)}>✖</button>
                    </div>

                    {/* Chat Messages Area */}
                    <div className="chat-messages">
                        {messages.map((msg, index) => (
                            <div key={index} className={`message ${msg.sender}`}>
                                {msg.text}
                            </div>
                        ))}
                    </div>

                    {/* Chat Input */}
                    <div className="chat-input">
                        <input
                            type="text"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            placeholder="Ask a question..."
                        />
                        <button onClick={sendMessage}>Send</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Chatbot;
